/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import { Dropdown, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import _, { valuesIn } from 'lodash';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import moment from 'moment';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import Checkbox from '@material-ui/core/Checkbox';
import { v3 } from 'uuid';
import Spinner from '../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SVGComponent from '../../../SharedModules/SVGComponents/SVGComponents';
import ErrorMessages from '../../../SharedModules/Errors/ErrorMessages';
import * as AppConstants from '../../../SharedModules/AppConstants';
import DisplaySuccessMessages from '../../../SharedModules/Errors/SuccessMessage';
import CommentIcon from '../../../assets/images/comment-dots.svg';
import CommentAndCorrespondenceComponent from '../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import CommentVisibleIcon from '../../../assets/images/commen-visible-icon.svg';
import SaveCancelPopup from '../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import {
  removeErr,
  tabHighLigther,
  makeFormDirty,
  checkActionAccessByRole,
} from '../../../SharedModules/utilities/utilities';
import {
  checkQuarterValidation,
  closeTab,
  convertQuaterToDate,
  redirectURLLink,
} from '../../../SharedModules/CommonUtilities/commonUtilities';
import CommonModal from '../../../SharedModules/Dialog/CommonModal';
import {
  selectedType,
  dispatchCellClick,
} from '../../Maintain/Contract/store/actions';
import TableGrid from '../../../SharedModules/Table/TableGridWithFeatures';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../SharedModules/AgGridUtilities/suppressNavigation';

import {
  setSelectManufacturerData,
  fetchAllManufacturerDetail,
  getContactDetails,
  maintainLabelerListData,
  setMaintainManufacturerTab,
} from '../../Maintain/Manufacturer/store/ManufacturerAction';
import { getAllManufacturerDetail } from '../../Maintain/DrugFamily/DrugFamilyDetails/store/actions';
import {
  getUnitConversionDetail,
  getNdcGrid,
  dispatchFirstTimeAdd,
  setCMSUnitType,
  SearchScreenRedux,
} from '../../Maintain/unitConversion/store/actions';
import { contractColumnDef, rebateColumnDef } from './tablehead';
import {
  getNDCDetails,
  setNDCErrorPopupMessage,
  setNDCDetails,
  setCurrentNDCDetailsIndex,
  setCurrentNDCDetailsSelected,
} from '../../Display/NDC/store/action';
import {
  // dispatchInvoiceDetailsByInvoiceNum,
  getInvoiceDetailsByInvoiceNum,
} from '../../Display/invoice/store/actions';
import {
  displayChecklist,
  getContractSeqList,
  getInvoiceDetailByInvoiceNum,
  getManuARForAllRpcNavFn,
  getManuARForSglRpcNavFn,
  getMfgBankruptcyCounts,
  goToMfgAccRec,
  undoBankruptMfg,
  updateBankruptMfg,
} from './ARCommonFunctions';
import { getArSummaryAllRpc } from './ReqAccReceivable/store/actions';
import {
  fldValueUpdate,
  getUnallocatedMfg,
  manufacturerArTbl,
  mfgARFirstLoad,
} from './MfgAccountsRec/store/actions';
import {
  BANKRUPT_CONFIRM_MSG,
  MFG_BANKRUPT_ERR,
  NOTHING_TO_PROCESS,
} from './AccountsRevConstants';
import {
  dispatchPerformDisputeDetailObj,
  dispatchSetDisplayCurrentDisputesPage,
  getDisplayCurrentDisputes,
} from '../../Tasks/PerformDisputeResolutions/store/actions';
import {
  getClaimTableInfo,
  navigateToClaim,
} from '../../Display/Claim/store/action';
import {
  dispatchInvoiceDetailsByInvoiceNum,
  getInvGridFlag,
  getInvoiceLetterTableData,
  getPrintCover,
  getRebateProgramCode,
  getSaveCoverLetter,
  searchInvoiceReportAction,
  setIsSearchClicked,
} from '../../Display/InvoiceReport/store/actions';
import { setDisplayCheckTableData } from '../../Display/Check/store/action';
import { clearReduxForFilterAndSort } from '../../../SharedModules/Table/store/Actions';
import { NO_CLAIM_FOUND } from '../../../SharedModules/Errors/constantMessageData';

export const NameTooltipComp = (props) => {
  const { data } = props;
  let name = '';
  if (data?.colDef?.headerName === 'Manufacturer Name') {
    name = data.data.mfgName;
  }
  if (data?.colDef?.headerName === 'Drug Name') {
    name = data.data.drugName;
  }
  if (data?.colDef?.headerName === 'Name') {
    name = data.data.name;
  }
  if (name && name.length > 20) {
    return (
      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
      >
        <div>{name && `${name}`}</div>
      </OverlayTrigger>
    );
  }
  return <div>{name}</div>;
};
export const RedTextRenderCompKeyChange = (props) => {
  // Create our number formatter.
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });
  const { data } = props;
  let value = '';
  if (data?.colDef?.headerName === 'Offset Due') {
    value = data.data.offsetDue;
  }
  if (data?.colDef?.headerName === 'Total Due') {
    value = data.data.totalDue;
  }
  if (data?.colDef?.headerName === 'Principal Paid') {
    value = data.data.amtPaid;
  }
  if (data?.colDef?.headerName === 'Offset Paid Amount') {
    value = data.data.offsetPaidAmt;
  }
  if (data?.colDef?.headerName === 'Base State Paid Amount') {
    value = data.data.baseStatePaidAmount;
  }
  if (data?.colDef?.headerName === 'Interest Paid') {
    value = data.data.interestPaid;
  }
  if (data?.colDef?.headerName === 'Current Invoice Amount') {
    value = data.data.currInvAMt;
  }
  if (data?.colDef?.headerName === 'Current Rebate Offset Amount') {
    value = data.data.currRoa;
  }
  if (data?.colDef?.headerName === 'Base State Rebate Amount') {
    value = data.data.baseStatePaidAmount;
  }
  if (data?.colDef?.headerName === 'Open Disputes') {
    value = data.data.disputeCount;
  }
  if (data?.colDef?.headerName === 'Dispute Amount') {
    value = data.data.disputeAmt;
  }
  if (data?.colDef?.headerName === 'Current Claim Paid Amount') {
    value = data.data.revisedReimburseAmt;
  }
  if (value === null || isNaN(parseFloat(value))) return value;
  if (value && parseFloat(value) < 0)
    return (
      <span style={{ color: '#a81f00' }}>
        {`(${formatter.format(-value).replace(/^(\D+)/, '$1 ')})`}
      </span>
    );
  return <span>{formatter.format(value).replace(/^(\D+)/, '$1 ')}</span>;
  // return value;
};
const ActionDropDownComp = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    data,
    displayBy,
    selectPgm,
    loadfn,
    selectedRebate,
    updateInvoiceBalancedHandler,
    extraData,
    undoInvoiceBalancedHandler,
    declareInvoiceBankruptHandler,
    undoDeclareInvoiceBankruptHandler,
    handleGoToAccRecNDCDetail,
    qtrInvoiceBalancedHandler,
    qtrUndoInvoiceBalancedHandler,
    handleShowDrugActivity,
    handleDeclareNDCBalanced,
    handleUndoDeclareNDCBalanced,
    handleModifyUnitsFromAR,
    handleSetUnitsToClaims,
    handleOverrideInterest,
    handleGoToQtrAccRec,
    handleEstimatePrincipalDue,
    getAllQuarterValue,
  } = props;
  const [openDlg, setOpenDlg] = React.useState(false);
  const [selectedPgm, setSelectedPgm] = React.useState();
  const [mfgBankDlg, setMfgBankDlg] = React.useState(false);
  const [mfgBankMsg, setMfgBankMsg] = React.useState();
  const [confirmAction, setConfirmAction] = React.useState(false);
  const [contractPopup, setContractPopup] = React.useState(false);
  const [msgPopup, setMsgPopup] = React.useState(false);
  const [titleMsg, setTitleMsg] = React.useState();
  const [contentMsg, setContentMsg] = React.useState();
  const [contractData, setContractData] = React.useState(false);
  const [selectedContarct, setSelectedContract] = React.useState();
  const [rowselected, setrowselected] = React.useState(false);
  const [isEnablebyRole, setIsEnablebyRole] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const { rbt_list } = useSelector(
    (state) => state?.sharedState?.AccountRecReducer
  );
  const searchContractState = useSelector(
    (state) => state.sharedState?.ContractReducer?.searchContractState
  );
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);

  // Role based access
  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);

  const goToManufacturerDetails = async (value) => {
    loadfn(true);
    const checkDetail = dispatch(
      getAllManufacturerDetail({
        showAllInd: false,
        mfgId: value,
      })
    );
    checkDetail
      .then((res) => {
        if (res.data?.status == '001') {
          const tempObj = {
            mfgId: res.data?.data?.mfgVO?.mfgId,
            mfgName: res.data?.data?.mfgVO?.mfgName,
            mfgTypeCd: res.data?.data?.mfgVO?.mfgTypeCd,
            updateManufacturer: true,
            name: res.data?.data?.mfgVO?.name,
          };
          dispatch(setSelectManufacturerData({}));
          dispatch(fetchAllManufacturerDetail(null));
          dispatch(getContactDetails(null));
          dispatch(maintainLabelerListData({}));
          dispatch(setMaintainManufacturerTab({}));
          const updateTabs =
            JSON.parse(localStorage.getItem('tabItemsData')) === null
              ? []
              : JSON.parse(localStorage.getItem('tabItemsData'));
          if (
            updateTabs.findIndex(
              (item) => item.navTo === '/manufacturer-detail'
            ) === -1
          ) {
            updateTabs.push({
              navTo: '/manufacturer-detail',
              value: 'Maintain Manufacturer',
            });
            localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
          }
          const result = dispatch(setSelectManufacturerData(tempObj));
          if (result && Object.keys(result).length > 0) {
            history.push({ pathname: '/manufacturer-detail' });
          }
        }
      })
      .catch((err) => {});
  };

  const goToNdcDetails = async (ndc, drugname) => {
    loadfn(true);
    const response = await getNDCDetails([{ ndc: ndc, drugName: drugname }]);
    if (response) {
      dispatch(setNDCErrorPopupMessage(null));
      dispatch(setCurrentNDCDetailsIndex(1));
      dispatch(setCurrentNDCDetailsSelected(response[0], 'All'));
      dispatch(setNDCDetails([{ ndc: ndc, drugName: drugname }]));
      redirectURLLink('/ndc-details', 'NDC Details', history, dispatch);
    }
  };

  const goToInvoiceDetails = async (data) => {
    loadfn(true);
    await dispatch(getInvoiceDetailsByInvoiceNum({ invoiceNum: data }));
    redirectURLLink('/display-invoice', 'Display Invoice', history, dispatch);
  };
  // Navigate to claims page from action dropdown
  const navigateToPage = (pathName, value) => {
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) == null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    if (updateTabs.findIndex((item) => item.navTo === pathName) === -1) {
      updateTabs.push({
        navTo: pathName,
        value: value,
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    }

    history.push({
      pathname: pathName,
    });
  };
  // Go to SELCETED CLAIMS screen
  const handleGotoClaims = async (data, rebatePgmAll) => {
    loadfn(true);
    dispatch(
      navigateToClaim(
        {
          rebateProgramCd: extraData.pgmCd === '-1' ? null : extraData.pgmCd,
          rebateProgramCdAll: rebatePgmAll ? 1 : null,
          paidQtr:
            getAllQuarterValue || extraData?.getQuarterValue || extraData?.qtr,
          searchByNdc: true,
          client: null,
          group: null,
          claimCategoryCd: null,
          plan: null,
          userID: logInUser?.toUpperCase(),
          // functionCode: 'Claim',
          // eventInquryKeyVO: [{ keyType: 'NDC', key: data.ndc }],
          drugSqnNum: data && data.drugSeqNum ? [data.drugSeqNum] : [],
        },
        () => {
          redirectURLLink(
            '/selected-claim',
            'Selected Claim',
            history,
            dispatch
          );
          // navigateToPage('/selected-claim', 'Selected Claim');
        },
        () => {
          loadfn(false);
          setMsgPopup(true);
          setTitleMsg('Claims');
          setContentMsg(NO_CLAIM_FOUND);
        }
      )
    );
    dispatch(getClaimTableInfo(true));
  };

  const getContractSeqNum = async (data) => {
    const payload = {
      mfgIds: [data.data.mfgId],
      rebateProgram: extraData.pgmCd,
      startQtr: extraData.startQtr,
      endQtr: extraData.endQtr,
    };

    const response = await dispatch(getContractSeqList(payload));
    if (response.message === 'SUCESS' && response.status === '001') {
      if (response?.contractInfoList?.length > 1) {
        setContractPopup(true);
        const tbldata = response.contractInfoList.map((obj) => {
          obj.name = obj.contractName;
          obj.startDate = obj.startDt;
          obj.endDate = obj.endDt;
          obj.rebatePgm = obj.rebateProgramCd;
          return obj;
        });
        setContractData(tbldata);
      } else if (response?.contractInfoList?.length === 1) {
        goToContract(data, response?.contractInfoList?.[0]);
      } else if (response?.contractSeqNumList.length === 0) {
        setMsgPopup(true);
        setTitleMsg('Contract Selection');
        setContentMsg(
          `No Contract associated for ${data.data.mfgName} manufacturer`
        );
      }
    }
  };

  const goToDisplayCheck = async (val) => {
    loadfn(true);
    const checkSearchResults = await dispatch(
      displayChecklist(val.checkLogNum)
    );
    dispatch(setDisplayCheckTableData(checkSearchResults));
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs.findIndex((item) => item.navTo === '/display-check') === -1
    ) {
      updateTabs.push({
        navTo: '/display-check',
        value: 'Display Check List',
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    }
    history.push({ pathname: '/display-check' });
  };

  const goToPrintedInvoice = async (data) => {
    loadfn(true);
    const invNum = data.invoiceNum || extraData.invoiceNum;
    const obj = {
      rebateProgram: extraData.pgmCd,
      templateTypes: ['COLLECT', 'COVER', 'DISPUTE'],
      // mfgId: e.data.mfgId,
      invoiceNumber: invNum,
      isSelectedByProQtrManu: true,
    };
    const res = await dispatch(
      getInvoiceDetailByInvoiceNum({ invoiceNum: invNum })
    );
    dispatch(dispatchInvoiceDetailsByInvoiceNum(res));
    dispatch(getInvoiceLetterTableData(obj));
    // dispatch(getRebateProgramCode(extraData.planType));
    await dispatch(
      getPrintCover({
        invoiceNum: [invNum],
        rebateProgramCd: extraData.pgmCd,
        userId: logInUser,
        duplicate: 'false',
      })
    );
    await dispatch(
      searchInvoiceReportAction({
        // ...searchInvoiceRequest,
        planType: extraData.planType,
        rebateProgramCode: extraData.pgmCd,
      })
    );
    await dispatch(getSaveCoverLetter(extraData.pgmCd));
    await dispatch(getInvGridFlag(extraData.pgmCd));
    await dispatch(setIsSearchClicked(true));
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/invoice-report-details',
      value: 'Invoice Report Details',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    history.push({
      pathname: '/invoice-report-details',
      invoiceDetailsByInvoiceNum: res.data,
    });
    // dispatch(getInvoiceDetailsByInvoiceNum({ invoiceNum: data.invoiceNum }));
    // redirectURLLink('/display-invoice', 'Display Invoice', history);
  };

  const goToContract = (data, seqnum) => {
    loadfn(true);
    dispatch(dispatchCellClick(true));
    dispatch(selectedType('C'));
    searchContractState.contractType = 'onSelect';
    searchContractState.selectedContractType = 'contractId';
    searchContractState.selectedRowData = seqnum?.contractSeqNum;
    searchContractState.selectedContractId = seqnum?.contractSeqNum;
    searchContractState.rebateProgramCode = extraData.pgmCd;
    searchContractState.searchContractDate = seqnum.startDt;
    dispatch(clearReduxForFilterAndSort('/createContract'));
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/createContract',
      value: 'Maintain Contract',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    history.push({
      pathname: '/createContract',
    });
  };

  const goToManufactureAccRec = async (data) => {
    loadfn(true);
    let payload = {
      planType: extraData.planType,
      mfgId: data.data.mfgId,
      startQtr: extraData.startQtr,
      endQtr: extraData.endQtr,
      useOfficialURA: extraData.useOfficialURA,
    };
    let unallocatedpayload = {
      planType: extraData.planType,
      mfgId: data.data.mfgId,
      startQtr: extraData.startQtr,
      endQtr: extraData.endQtr,
      useOfficialURA: extraData.useOfficialURA,
    };
    if (extraData.pgmInfo.indexOf('All') !== -1) {
      payload = { ...payload, rebateProgram: '' };
      const data = await dispatch(getManuARForAllRpcNavFn(payload));
      const manuFactuAllData = {
        [`${payload?.mfgId}-${'All'}`]:
          data.acctRecvOneMfgAllRpcSummaryResponseVo,
      };
      dispatch(manufacturerArTbl(manuFactuAllData));
      unallocatedpayload = {
        ...unallocatedpayload,
        allRebateProgIndicator: 1,
        rebateProgram: '',
      };
    } else {
      payload = { ...payload, rebateProgram: extraData.rebateProgramCode };
      const data = await dispatch(getManuARForSglRpcNavFn(payload));
      const manuFactuData = {
        [`${payload?.mfgId}-${payload?.rebateProgram}`]:
          data.accountReceivableDetailSforSingleMfgGridResponseVOs,
      };
      dispatch(manufacturerArTbl(manuFactuData));
      unallocatedpayload = {
        ...unallocatedpayload,
        allRebateProgIndicator: 0,
        rebateProgram: extraData.rebateProgramCode,
      };
    }
    const manuFactuHeaderData = {
      [`${payload?.mfgId}-${
        payload?.rebateProgram ? payload?.rebateProgram : 'All'
      }`]: {
        ...extraData,
        mfgName: data.data.mfgName,
        ...payload,
      },
    };
    dispatch(fldValueUpdate(manuFactuHeaderData));
    dispatch(getUnallocatedMfg(unallocatedpayload));
    goToMfgAccRec(history, dispatch, payload);
    dispatch(mfgARFirstLoad(false));
    // localStorage.setItem('mfgAccRec', true);
  };

  const goToDisplayCurrentDisputes = async (data) => {
    loadfn(true);
    const qtrData = data.data.qtr || extraData.quarter;
    const payForDetail = {
      rebateProgram: extraData.pgmCd,
      quarter: qtrData,
      mfgId: extraData.mfgId,
    };
    const processBtnResult = await dispatch(
      getDisplayCurrentDisputes(payForDetail)
    );
    const response = processBtnResult && processBtnResult.payload;
    if (
      response &&
      response.displayDispHeaderAndGridRespVOList &&
      response.displayDispHeaderAndGridRespVOList.length > 0
    ) {
      const Obj = {
        mfgID: extraData.mfgId,
        mfgName: extraData.mfgName,
        rebatePrograme: extraData.pgmCd,
        qtr: qtrData,
      };
      dispatch(dispatchPerformDisputeDetailObj(Obj));
      dispatch(
        dispatchSetDisplayCurrentDisputesPage({
          pageCount: 1,
          disputesList: response.displayDispHeaderAndGridRespVOList,
        })
      );
      redirectURLLink(
        '/displayCurrentDisputes',
        'Display Current Disputes',
        history,
        dispatch
      );
    } else {
      setTitleMsg('');
      setContentMsg(
        'No Dispute Invoice found for this labeler will be displayed'
      );
      setMsgPopup(true);
      loadfn(false);
    }
  };

  const onRowSelect = (val) => {
    const [row] = val.api.getSelectedRows();
    setSelectedPgm(row);
    setrowselected(true);
  };

  const updateMfgBankrupt = async (data) => {
    loadfn(true);
    const payload = {
      mfgId: data.data.mfgId,
      rebateProgramCd: extraData.pgmCd === '-1' ? 'ALL' : extraData.pgmCd,
      startQtr: extraData.startQtr,
      endQtr: extraData.endQtr,
    };
    const result = await dispatch(updateBankruptMfg(payload));
    if (result?.status === '001' && result?.message === 'SUCESS') {
      setMfgBankMsg(result?.responseMessage);
      try {
        const refreshPayload = {
          planType: extraData.planType,
          startQtr: extraData.startQtr,
          endQtr: extraData.endQtr,
          useOfficialURA: extraData.useOfficialURA
            ? extraData.useOfficialURA === 'Official' ||
              extraData.useOfficialURA === 1
              ? 1
              : 0
            : 0,
          allRebateProgramIndicator:
            extraData?.pgmInfo && extraData.pgmInfo.indexOf('All') !== -1
              ? 1
              : 0,
          allMfgIndicator: 1,
          rebateProgramCode: extraData.pgmCd || '',
          mfgId: '',
        };
        dispatch(
          getArSummaryAllRpc(refreshPayload, {
            ...refreshPayload,
            ...extraData,
          })
        );
      } catch (e) {}
    } else {
      setMfgBankMsg(MFG_BANKRUPT_ERR);
    }
    setMfgBankDlg(true);
    loadfn(false);
  };

  const undoDeclaredMfgBankrupt = async (data) => {
    const payload = {
      mfgId: data.data.mfgId,
      rebateProgramCd: extraData.pgmCd !== '-1' ? extraData.pgmCd : 'ALL',
      startQtr: extraData.startQtr,
      endQtr: extraData.endQtr,
    };
    const result = await dispatch(undoBankruptMfg(payload));
    if (result?.status === '001' && result?.message === 'SUCESS') {
      setMfgBankMsg(result?.responseMessage);
    } else {
      setMfgBankMsg(MFG_BANKRUPT_ERR);
    }
    setMfgBankDlg(true);
    loadfn(false);
  };

  const goToMaintainUnitConversion = async (drugSeqNum) => {
    loadfn(true);
    dispatch(dispatchFirstTimeAdd(true));
    dispatch(setCMSUnitType({}));
    dispatch(
      SearchScreenRedux({
        state: {
          selectTypeCd: 'AN',
          selectByCd: 'Mn',
          allmanufacturercd: true,
          openConversionsCd: true,
          searchTypeState: {
            valueSelectedRedux: 'NDC',
            ndcSearchTextRedux: '',
            ndcNameSearchTextRedux: '',
            ndcLeftTableDataRedux: [],
            ndcRightTableDataRedux: [],
            labelerTableDataRedux: [],
          },
        },
      })
    );
    dispatch(getUnitConversionDetail({ drugSeqNum: [drugSeqNum] }));
    const result = await dispatch(getNdcGrid({ drugSeqNum: drugSeqNum }));
    // if (result.payLoad && result.payLoad?.length > 0) {
    redirectURLLink(
      '/unitConversion-detail',
      'Display Unit Conversion for NDC',
      history,
      dispatch
    );
    // }
  };

  const undoBankruptHandler = async (data) => {
    const payload = {
      mfgId: data.data.mfgId,
      rebateProgramCd: extraData.pgmCd !== '-1' ? extraData.pgmCd : 'ALL',
      startQtr: extraData.startQtr,
      endQtr: extraData.endQtr,
    };
    const counts = await dispatch(getMfgBankruptcyCounts(payload));
    if (counts.message === 'SUCESS' && counts.status === '001') {
      const { bankruptcyStatusCount, otherStatusCount } =
        counts.bankruptcyCounts;
      if (bankruptcyStatusCount === 0 && otherStatusCount === 0) {
        setMfgBankMsg(NOTHING_TO_PROCESS);
        setMfgBankDlg(true);
      } else if (bankruptcyStatusCount > 0 && otherStatusCount === 0) {
        loadfn(true);
        undoDeclaredMfgBankrupt(data);
      } else {
        setConfirmAction(true);
      }
    } else {
      setMfgBankMsg(MFG_BANKRUPT_ERR);
      setMfgBankDlg(true);
    }
  };

  const [anchorEl, setAnchorEl] = React.useState();
  const [open, setOpen] = React.useState(false);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(!open);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleMenuKeyDown = (event) => {
    const { key } = event;
    if (key === 'ArrowDown' || key === 'ArrowUp') {
      event.stopPropagation();
    }
  };

  return (
    <>
      {_.includes(
        ['ndcdetail', 'mfgAr', 'mfg', 'NDCActivity', 'qtrAccRec', 'qtrSmry'],
        displayBy
      ) && (
        <>
          <IconButton
            aria-label="actions"
            id="long-button"
            className="frr-export-align"
            aria-controls={open ? 'long-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-haspopup="true"
            onClick={handleClick}
          >
            <SVGComponent iconName="Icon-export" />
          </IconButton>
          {displayBy === 'ndcdetail' && (
            <Menu
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              MenuListProps={{
                onKeyDown: handleMenuKeyDown,
                autoFocusItem: true,
              }}
              className="export_dropdown"
            >
              {!selectPgm && (
                <MenuItem
                  role="button"
                  onClick={() => {
                    handleClose();
                    handleShowDrugActivity(data.data);
                  }}
                >
                  Show Drug Activity
                </MenuItem>
              )}
              {!selectPgm && (
                <MenuItem
                  role="button"
                  onClick={() => {
                    handleClose();
                    handleEstimatePrincipalDue(data.data);
                  }}
                >
                  Estimate Principal Due
                </MenuItem>
              )}
              {!selectPgm && (
                <MenuItem
                  disabled={!isEnablebyRole}
                  role="button"
                  onClick={() => {
                    handleClose();
                    handleModifyUnitsFromAR(data.data);
                  }}
                >
                  Modify Units From A/R
                </MenuItem>
              )}
              {!selectPgm && (
                <MenuItem
                  disabled={!isEnablebyRole}
                  role="button"
                  onClick={() => {
                    handleClose();
                    handleSetUnitsToClaims(data.data);
                  }}
                >
                  Set Units To Claims
                </MenuItem>
              )}
              {!selectPgm && (
                <MenuItem
                  disabled={!isEnablebyRole}
                  role="button"
                  onClick={() => {
                    handleClose();
                    handleOverrideInterest(data.data);
                  }}
                >
                  Override Interest
                </MenuItem>
              )}
              {!selectPgm && (
                <MenuItem
                  disabled={!isEnablebyRole}
                  role="button"
                  onClick={() => {
                    handleClose();
                    handleDeclareNDCBalanced(data);
                  }}
                >
                  Declare an NDC Balanced
                </MenuItem>
              )}
              {!selectPgm && (
                <MenuItem
                  disabled={!isEnablebyRole}
                  role="button"
                  onClick={() => {
                    handleClose();
                    handleUndoDeclareNDCBalanced(data);
                  }}
                >
                  Undo Declare NDC Balanced
                </MenuItem>
              )}
              {!selectPgm && (
                <MenuItem
                  onClick={() => {
                    handleClose();
                    goToInvoiceDetails(extraData.invoiceNum);
                  }}
                >
                  Go To Invoice Detail
                </MenuItem>
              )}
              <MenuItem
                role="button"
                onClick={() => {
                  handleClose();
                  handleGotoClaims(data?.data, selectPgm);
                }}
              >
                Go to Claims
              </MenuItem>
              <MenuItem
                role="button"
                onClick={() => {
                  handleClose();
                  goToNdcDetails(data.data.ndc, data.data.drugName);
                }}
              >
                Go to NDC
              </MenuItem>
              {!selectPgm && (
                <MenuItem
                  role="button"
                  onClick={() => {
                    handleClose();
                    goToPrintedInvoice(data.data);
                  }}
                >
                  Go to Printed Invoice
                </MenuItem>
              )}
              {!selectPgm && (
                <MenuItem
                  role="button"
                  onClick={() => {
                    handleClose();
                    goToDisplayCurrentDisputes(data);
                  }}
                >
                  Go to Dispute Resolution
                </MenuItem>
              )}
              <MenuItem
                role="button"
                onClick={() => {
                  handleClose();
                  goToMaintainUnitConversion(data?.data.drugSeqNum);
                }}
              >
                Go To Maintain Unit Conversion
              </MenuItem>
            </Menu>
          )}
          {displayBy === 'mfgAr' && (
            <Menu
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              MenuListProps={{
                onKeyDown: handleMenuKeyDown,
                autoFocusItem: true,
              }}
              className="export_dropdown"
            >
              {selectPgm && (
                <MenuItem
                  onClick={() => {
                    handleClose();
                    setOpenDlg(true);
                  }}
                >
                  Select Rebate Program
                </MenuItem>
              )}
              {!selectPgm && (
                <MenuItem
                  disabled={!isEnablebyRole}
                  onClick={() => {
                    if (updateInvoiceBalancedHandler) {
                      handleClose();
                      updateInvoiceBalancedHandler(data);
                    }
                  }}
                >
                  Declare an Invoice Balanced
                </MenuItem>
              )}
              {!selectPgm && (
                <MenuItem
                  disabled={!isEnablebyRole}
                  onClick={() => {
                    if (undoInvoiceBalancedHandler) {
                      handleClose();
                      undoInvoiceBalancedHandler(data);
                    }
                  }}
                >
                  Undo Declare Invoice Balanced
                </MenuItem>
              )}
              {!selectPgm && (
                <MenuItem
                  disabled={!isEnablebyRole}
                  onClick={() => {
                    if (declareInvoiceBankruptHandler) {
                      handleClose();
                      declareInvoiceBankruptHandler(data);
                    }
                  }}
                >
                  Declare Invoice Bankrupt
                </MenuItem>
              )}
              {!selectPgm && (
                <MenuItem
                  disabled={!isEnablebyRole}
                  onClick={() => {
                    if (undoDeclareInvoiceBankruptHandler) {
                      handleClose();
                      undoDeclareInvoiceBankruptHandler(data);
                    }
                  }}
                >
                  Undo Declare Invoice Bankrupt
                </MenuItem>
              )}
              <MenuItem
                onClick={() => {
                  handleClose();
                  handleGoToAccRecNDCDetail(data);
                }}
              >
                Go To Accounts Receivable NDC Detail
              </MenuItem>
              {!selectPgm && (
                <MenuItem
                  onClick={() => {
                    handleClose();
                    goToInvoiceDetails(data.data.invoiceNum);
                  }}
                >
                  Go To Invoice Detail
                </MenuItem>
              )}
              {!selectPgm && (
                <MenuItem
                  onClick={() => {
                    handleClose();
                    goToPrintedInvoice(data.data);
                  }}
                >
                  Go To Printed Invoice
                </MenuItem>
              )}
              {!selectPgm && (
                <MenuItem
                  onClick={() => {
                    handleClose();
                    goToDisplayCurrentDisputes(data);
                  }}
                >
                  Go To Dispute Resolution
                </MenuItem>
              )}
            </Menu>
          )}
          {displayBy === 'mfg' && (
            <Menu
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              className="export_dropdown"
            >
              {selectPgm && (
                <MenuItem
                  onClick={() => {
                    handleClose();
                    setOpenDlg(true);
                  }}
                >
                  Select Rebate Program
                </MenuItem>
              )}
              <MenuItem
                disabled={data.data.disableBankruptMenu || !isEnablebyRole}
                onClick={() => {
                  handleClose();
                  updateMfgBankrupt(data);
                }}
              >
                Declare Manufacturer Bankrupt
              </MenuItem>
              <MenuItem
                disabled={data.data.disableBankruptMenu || !isEnablebyRole}
                onClick={() => {
                  handleClose();
                  undoBankruptHandler(data);
                }}
              >
                Undo Declare Manufacturer Bankrupt
              </MenuItem>
              <MenuItem
                disabled={selectPgm}
                onClick={() => {
                  handleClose();
                  getContractSeqNum(data);
                }}
              >
                Go To Contract
              </MenuItem>
              <MenuItem
                data-testid="menu1"
                onClick={() => {
                  handleClose();
                  goToManufacturerDetails(data.data.mfgId);
                }}
              >
                Go To Manufacturer
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleClose();
                  goToManufactureAccRec(data);
                }}
              >
                Go To Manufacturer Accounts Receivables
              </MenuItem>
            </Menu>
          )}
          {displayBy === 'NDCActivity' && (
            <Menu
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              className="export_dropdown"
            >
              {selectPgm && (
                <MenuItem
                  disabled={data?.data?.checkLogNum == 0}
                  onClick={() => {
                    handleClose();
                    goToDisplayCheck(data.data);
                  }}
                >
                  Go to Display Check
                </MenuItem>
              )}
            </Menu>
          )}
          {displayBy === 'qtrAccRec' && (
            <Menu
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              className="export_dropdown"
            >
              {selectPgm && (
                <MenuItem
                  role="button"
                  onClick={() => {
                    handleClose();
                    setOpenDlg(true);
                  }}
                >
                  Select Rebate Program
                </MenuItem>
              )}
              {!selectPgm && (
                <MenuItem
                  disabled={!isEnablebyRole}
                  role="button"
                  onClick={() => {
                    if (qtrInvoiceBalancedHandler) {
                      handleClose();
                      qtrInvoiceBalancedHandler(
                        data,
                        extraData.bl,
                        extraData.ov,
                        extraData.pf
                      );
                    }
                  }}
                >
                  Declare An Invoice Balanced
                </MenuItem>
              )}
              {!selectPgm && (
                <MenuItem
                  disabled={!isEnablebyRole}
                  role="button"
                  onClick={() => {
                    if (qtrUndoInvoiceBalancedHandler) {
                      handleClose();
                      qtrUndoInvoiceBalancedHandler(
                        data,
                        extraData.bl,
                        extraData.ov,
                        extraData.pf
                      );
                    }
                  }}
                >
                  Undo Declare Invoice Balanced
                </MenuItem>
              )}
              {!selectPgm && (
                <MenuItem
                  role="button"
                  onClick={() => {
                    handleClose();
                    goToInvoiceDetails(data.data.invoiceNum);
                  }}
                >
                  Go to Invoice Detail
                </MenuItem>
              )}
              {!selectPgm && (
                <MenuItem
                  role="button"
                  onClick={() => {
                    handleClose();
                    goToPrintedInvoice(data.data);
                  }}
                >
                  Go to Printed Invoice
                </MenuItem>
              )}
              <MenuItem
                role="button"
                onClick={() => {
                  handleClose();
                  handleGoToAccRecNDCDetail(data?.data);
                }}
              >
                Go to Accounts Receivable NDC Detail
              </MenuItem>
            </Menu>
          )}
          {displayBy === 'qtrSmry' && (
            <Menu
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              className="export_dropdown"
            >
              <MenuItem
                role="button"
                onClick={() => {
                  handleClose();
                  handleGoToQtrAccRec(data?.data);
                }}
              >
                Go To Quarterly Accounts Receivable
              </MenuItem>
              <MenuItem
                role="button"
                onClick={() => {
                  handleClose();
                  setOpenDlg(true);
                }}
              >
                Select Rebate Program
              </MenuItem>
            </Menu>
          )}
        </>
      )}
      <CommonModal
        open={openDlg}
        viewAction
        viewHeader
        onOk={() => {
          if (selectedPgm) {
            setOpenDlg(false);
            selectedRebate(selectedPgm);
          }
        }}
        okTitle="Ok"
        disableOk={!rowselected}
        onClose={() => setOpenDlg(false)}
        closeTitle="Cancel"
        modalTitle="Rebate Program Selection"
        childrenComponent={
          <TableGrid
            rowData={rbt_list || []}
            columnDefs={rebateColumnDef}
            gridHeight={AppConstants.GRID_HEIGHT}
            onSelect={onRowSelect}
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            cellClickedListener={
              // displayBy === 'mfg'
              (val) => {
                const [row] = val.api.getSelectedRows();
                setOpenDlg(false);
                selectedRebate(row);
                loadfn(true);
              }
              // : null
            }
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            exportFile
            fileName="Rebate Programs"
            childPopup
          />
        }
      />
      <CommonModal
        open={mfgBankDlg}
        viewAction
        className="dialog-420"
        viewHeader
        onOk={() => setMfgBankDlg(false)}
        okTitle="Ok"
        onClose={() => setMfgBankDlg(false)}
        modalTitle="Manufacturer Bankrupt"
        childrenComponent={mfgBankMsg}
      />
      <CommonModal
        open={confirmAction}
        viewAction
        className="dialog-420"
        viewHeader
        onOk={() => {
          setConfirmAction(false);
          updateMfgBankrupt(data);
          loadfn(true);
        }}
        okTitle="Ok"
        closeTitle="Cancel"
        onClose={() => setConfirmAction(false)}
        modalTitle="Manufacturer Bankrupt"
        childrenComponent={BANKRUPT_CONFIRM_MSG}
      />
      <CommonModal
        open={contractPopup}
        data-testid="commonModal1"
        viewAction
        viewHeader
        onOk={() => {
          if (selectedContarct) {
            setContractPopup(false);
            goToContract(data, selectedContarct);
          }
        }}
        disableOk={!selectedContarct}
        okTitle="Ok"
        onClose={() => {
          setContractPopup(false);
          setSelectedContract();
        }}
        closeTitle="Cancel"
        modalTitle="Contract Selection"
        childrenComponent={
          <TableGrid
            rowData={contractData || []}
            columnDefs={contractColumnDef}
            gridHeight={AppConstants.GRID_HEIGHT}
            onSelect={(val) => {
              const [row] = val.api.getSelectedRows();
              setSelectedContract(row);
            }}
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            cellClickedListener={(val) => {
              const [row] = val.api.getSelectedRows();
              goToContract(data, row);
            }}
            frameworkComponents={{
              FullNameRender: (cellInfo) => {
                return <NameTooltipComp data={cellInfo} />;
              },
            }}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            exportFile
            fileName="Contract"
            childPopup
          />
        }
      />
      <CommonModal
        open={msgPopup}
        viewAction
        className="dialog-420"
        viewHeader
        onOk={() => setMsgPopup(false)}
        okTitle="Ok"
        onClose={() => setMsgPopup(false)}
        modalTitle={titleMsg}
        childrenComponent={contentMsg}
      />
    </>
  );
};
export default ActionDropDownComp;
